import type { ToolId } from "../core/index.js";
import { TOOLS } from "./toolbar.js";

export class StatusBar {
  private readonly element: HTMLElement;
  private readonly toolElement: HTMLElement;
  private readonly coordsElement: HTMLElement;
  private readonly sizeElement: HTMLElement;
  private readonly messageElement: HTMLElement;

  constructor(container: HTMLElement) {
    this.element = container;
    this.element.className = "status-bar";
    this.element.setAttribute("role", "status");
    this.element.setAttribute("aria-live", "polite");

    this.toolElement = document.createElement("div");
    this.toolElement.className = "status-item status-tool";

    this.coordsElement = document.createElement("div");
    this.coordsElement.className = "status-item status-coords";

    this.sizeElement = document.createElement("div");
    this.sizeElement.className = "status-item status-size";

    this.messageElement = document.createElement("div");
    this.messageElement.className = "status-item status-message";

    this.element.appendChild(this.toolElement);
    this.element.appendChild(this.coordsElement);
    this.element.appendChild(this.sizeElement);
    this.element.appendChild(this.messageElement);

    this.setTool("pencil");
    this.setCoords(null);
    this.setSize(16, 16);
    this.setMessage("Bereit");
  }

  public setTool(toolId: ToolId): void {
    const tool = TOOLS.find((t) => t.id === toolId);
    const label = tool ? tool.label : toolId;
    this.toolElement.textContent = `Werkzeug: ${label}`;
  }

  public setCoords(coords: { x: number; y: number } | null): void {
    if (coords === null) {
      this.coordsElement.textContent = "X: --, Y: --";
    } else {
      this.coordsElement.textContent = `X: ${coords.x}, Y: ${coords.y}`;
    }
  }

  public setSize(width: number, height: number): void {
    this.sizeElement.textContent = `${width} × ${height} px`;
  }

  public setMessage(msg: string): void {
    this.messageElement.textContent = msg;
  }
}
